/**
 * @generated SignedSource<<e682592e3ceca0f938887f2aea789bec>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/

export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
export enum LicenseStatus {
  ACTIVE = "ACTIVE",
  SUSPENDED = "SUSPENDED",
  UNLICENSED = "UNLICENSED",
}
export type LicensedProductsQuery_confluence_tenantContext_ConfluenceTenantContext_licensedProducts_LicensedProduct =
  {
    __typename?: "LicensedProduct";
    licenseStatus: LicenseStatus;
    productKey: string;
  };
export type LicensedProductsQuery_confluence_tenantContext_ConfluenceTenantContext =
  {
    __typename?: "ConfluenceTenantContext";
    licensedProducts: Array<LicensedProductsQuery_confluence_tenantContext_ConfluenceTenantContext_licensedProducts_LicensedProduct>;
  };
export type LicensedProductsQuery_Query = {
  __typename?: "Query";
  confluence_tenantContext: LicensedProductsQuery_confluence_tenantContext_ConfluenceTenantContext | null;
};
export type LicensedProductsQueryVariables = Exact<{
  [key: string]: never;
}>;
export type LicensedProductsQuery = LicensedProductsQuery_Query;
